import { required, helpers } from 'vuelidate/lib/validators';

const validations = {
    title: {
      required,
    },
    code: {
      required,
    },
    discount: {
      required,
      numeric: helpers.regex('numeric', /^[0-9]*$/),
    },
    businessType: {
      required,
    },
    minimumTotalAmount: {
      numeric: helpers.withParams({ type: 'numeric' }, value => {
        if (value === null || value === '') {
          return true; 
        }
        return /^[0-9]*$/.test(value);
      }),
    },
    startDate: {
      required,
    },
    endDate: {
      required,
    },
    limitationUsageNumber: {
      required,
      numeric: helpers.regex('numeric', /^[0-9]*$/),
    },
  };
  
  export default validations;